module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "padding": "3px"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("ABD")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("D. N. Freedman (ed.), "), _c('i', [_vm._v("The Anchor Bible Dictionary")]), _vm._v(". New York, 1992.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("ANET")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("J. B. Pritchard (ed.), "), _c('i', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(",20 3rd edn. Princeton, 1969.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("AV")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Authorized Version of the Bible, 1611.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("BA")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Biblical Archaeologist")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("BAR")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Biblical Archaeology Review")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("BDB")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("F. Brown, S. R. Driver and C. A. Briggs, "), _c('i', [_vm._v("A Hebrew and English Lexicon of the Old Testament")]), _vm._v(". Oxford, 1907.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("BDF")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("F. Blass and A. Debrunner, "), _c('i', [_vm._v("A Greek Grammar of the New Testament and Other Early Christian Literature")]), _vm._v(". Translated and revised by R. W. Funk. Chicago, 1961.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("BHS")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("K. Elliger and W. Rudolph, "), _c('i', [_vm._v("Biblica Hebraica Stuttgartensia")]), _vm._v(", 3rd edn. Stuttgart, 1987.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("BJRL")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Bulletin of the John Rylands Library")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EVV")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("English versions.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Gibson")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("J. C. L. Gibson, "), _c('i', [_vm._v("Davidson’s Introductory Hebrew Grammar: Syntax")]), _vm._v(", 4th edn. Edinburgh, 1994.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("GKC")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("E. Kautzsch (ed.), "), _c('i', [_vm._v("Gesenius’ Hebrew Grammar")]), _vm._v(". Revised by A. E. Cowley. Oxford, 1910.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Joüon")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("P. Joüon, "), _c('i', [_vm._v("A Grammar of Biblical Hebrew")]), _vm._v(". Translated and revised by T. Muraoka. Rome, 1991.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("JSOT")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Journal for the Study of the Old Testament")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("KB")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("L. Koehler and W. Baumgartner, "), _c('i', [_vm._v("The Hebrew and Aramaic Lexicon of the Old Testament")]), _vm._v(". Translated by M. E. J. Richardson. Volume I. Leiden, 1994.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LXX")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Septuagint (Greek version of the Old Testament).")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MT")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Masoretic Text.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NRSV")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("The New Revised Standard Version")]), _vm._v(", Anglicized Edition, 1989, 1995.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("OCD")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("N. G. L. Hammond and H. H. Scullard (eds.), "), _c('i', [_vm._v("Oxford Classical Dictionary")]), _vm._v(", 2nd edn. Oxford, 1970.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }), _c('i', [_vm._v("OTS")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Oudtestamentische Studiën")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("REB")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("The Revised English Bible")]), _vm._v(", 1989.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RSV")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("The Revised Standard Version")]), _vm._v(", 1952, 1971, 1973.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("SJT")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Scottish Journal of Theology")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("TDNT")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("G. Kittel and G. Friedrich, "), _c('i', [_vm._v("Theological Dictionary of the New Testament")]), _vm._v(". Translated by G. W. Bromiley. 10 volumes. Grand Rapids, 1964-76.")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("TrinJ")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Trinity Journal")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("VT")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Vetus Testamentum")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "padding": "3px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("WO’C")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("B. K. Waltke and M. O’Connor, "), _c('i', [_vm._v("An Introduction to Biblical Hebrew Syntax")]), _vm._v(". Winona Lake, 1990.")])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c31fa91e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/pre4.vue
// module id = 72
// module chunks = 0